import React from "react";
import { PasswordInput } from "../../Components/TextInput";
import { PrimaryButton } from "../../Components/PrimaryButton";
import { getStates, getCities } from "../../Utils/ibge";
import { maskCPF, maskTEL, maskDATA } from "../../Utils/masks";
import { auth, db } from "../../fire";
import { toast } from "react-toastify";

// Utils
import { toBr as dateToBr } from '../../Utils/date'

export class Register extends React.Component {
  state = {
    formData: {
      nome: "",
      sobrenome: "",
      email: "",
      cpf: "",
      telefone: "",
      estado: "",
      cidade: "",
      escolaridade: "",
      formacao: "",
      nascimento: "",
      password: ""
    },
    states: [],
    cities: []
  };

  componentDidMount() {
    this.getStates();
  }

  getStates = async () => {
    const states = await getStates();

    this.setState({ states });
  };

  updateFormData = (name, value) => {
    const { formData } = this.state;

    this.setState({
      formData: {
        ...formData,
        [name]: value
      }
    });
  };

  register = async () => {
    try {
      const { formData } = this.state;

      this.setState({ isSigninIn: true, error: "" });

      const normalizedData = {
        ...formData,
        autentificado: false,
        nascimento: new Date(dateToBr(formData.nascimento)),
        cpf: Number(formData.cpf.replace(/\D/g, "")),
        telefone: Number(formData.telefone.replace(/\D/g, ""))
      };

      const { user } = await auth.createUserWithEmailAndPassword(
        formData.email,
        formData.password
      );

      normalizedData.uid = user.uid;

      delete normalizedData.password;

      await db
        .collection("users")
        .doc(user.uid)
        .set(normalizedData);

      toast(
        "Cadastro concluído com sucesso, aguarde a aprovação para ter acesso a plataforma",
        {
          type: "info",
          onOpen: () => {
            setTimeout(() => {
              window.location.href = "/";
            }, 3000);
          }
        }
      );
    } catch (error) {
      console.log({ error });

      if (error.code === "auth/email-already-in-use") {
        this.setState({
          error: "Já existe uma conta com este endereço de email"
        });
      } else {
        this.setState({
          error:
            "Erro desconhecido, por favor, cheque os dados e tente novamente"
        });
      }
    } finally {
      this.setState({
        isSigninIn: false
      });
    }
  };

  onSelectState = async stateID => {
    try {
      var cities = [],
          state = 'none'

      if (stateID !== 'none') {
        cities = await getCities(stateID)
        state = this.state.states.find(state => state.id === Number(stateID)).nome
      }

      this.setState({ cities }, () => {
        this.updateFormData(
          "estado",
          state
        );
      });
    } catch (error) {}
  };

  changeCity = e => {
    var city = 'none'

    if (e.target.value !== 'none') {
      city = this.state.cities.find(
        city => city.id === Number(e.target.value)
      ).nome
    }

    this.updateFormData(
      "cidade",
      city
    );
  }

  render() {
    const { formData, isSigninIn, error } = this.state;

    return (
      <div className="container pt-5">
        <div className="row">
          <div className="col">
            <h1 className="text-center h2 pb-5">Cadastre-se</h1>
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          <div className="col-lg-6 col-md-8 col-sm-12">
            <form
              onSubmit={e => {
                e.preventDefault();
                this.register();
              }}
            >
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="nome">Nome</label>
                    <input
                      value={formData.nome}
                      onChange={e =>
                        this.updateFormData(
                          e.currentTarget.id,
                          e.currentTarget.value
                        )
                      }
                      type="text"
                      className="form-control"
                      id="nome"
                      placeholder="Digite seu nome"
                      required
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="sobrenome">Sobrenome</label>
                    <input
                      value={formData.sobrenome}
                      onChange={e =>
                        this.updateFormData(
                          e.currentTarget.id,
                          e.currentTarget.value
                        )
                      }
                      type="text"
                      className="form-control"
                      id="sobrenome"
                      placeholder="Digite seu sobrenome"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  value={formData.email}
                  onChange={e =>
                    this.updateFormData(
                      e.currentTarget.id,
                      e.currentTarget.value
                    )
                  }
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Digite seu email"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="cpf">CPF</label>
                <input
                  value={formData.cpf}
                  onChange={ e => this.updateFormData(e.target.id, maskCPF(e.target.value)) }
                  type="text"
                  className="form-control"
                  id="cpf"
                  placeholder="Digite seu CPF"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="telefone">Telefone</label>
                <input
                  value={formData.telefone}
                  onChange={ e => this.updateFormData(e.target.id, maskTEL(e.target.value)) }
                  type="tel"
                  className="form-control"
                  id="telefone"
                  placeholder="Digite seu telefone"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="nascimento">Data de nascimento</label>
                <input
                  value={formData.nascimento}
                  onChange={ e => this.updateFormData(e.target.id, maskDATA(e.target.value)) }
                  type="text"
                  className="form-control"
                  id="nascimento"
                  placeholder="Digite sua data de nascimento"
                  required
                  pattern=".{10,}"
                />
                <small className="form-text text-muted">Ex. 01/01/2001</small>
              </div>
              <div className="form-group">
                <label htmlFor="escolaridade">Escolaridade</label>
                <input
                  value={formData.escolaridade}
                  onChange={e =>
                    this.updateFormData(
                      e.currentTarget.id,
                      e.currentTarget.value
                    )
                  }
                  type="text"
                  className="form-control"
                  id="escolaridade"
                  placeholder="Digite sua escolaridade"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="formacao">Formação</label>
                <input
                  value={formData.formacao}
                  onChange={e =>
                    this.updateFormData(
                      e.currentTarget.id,
                      e.currentTarget.value
                    )
                  }
                  type="text"
                  className="form-control"
                  id="formacao"
                  placeholder="Digite sua formação"
                  required
                />
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="estado">Estado</label>
                    <select
                      className="form-control"
                      id="estado"
                      onChange={e => {
                        this.onSelectState(e.target.value);
                      }}
                      required
                    >
                      <option value="none">Selecionar</option>
                      {this.state.states.map(state => (
                        <option key={state.id} value={state.id}>
                          {state.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="cidade">Cidade</label>
                    <select
                      onChange={ e => this.changeCity }
                      className="form-control"
                      id="cidade"
                      required
                    >
                      <option value="none">Selecionar</option>
                      {this.state.cities.map(c => (
                        <option key={c.id} value={c.id}>
                          {c.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="password">Senha</label>
                <PasswordInput
                  value={formData.password}
                  onChange={e =>
                    this.updateFormData(
                      e.currentTarget.id,
                      e.currentTarget.value
                    )
                  }
                  required
                  id="password"
                  className="form-control"
                  placeholder="••••••••"
                  minLength={8}
                />
              </div>
              {<p className="text-center text-danger pt-4 pb-4">{error}</p>}
              <PrimaryButton
                type="submit"
                disabled={isSigninIn}
                block
                className="mb-5"
              >
                {isSigninIn ? "Cadastrando" : "Cadastrar"}
              </PrimaryButton>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
